import React, { useEffect, useImperativeHandle, useState } from "react";
import { useDispatch } from "react-redux";
import { default as ReactSelect, components } from "react-select";
import Maybe from "components/__new/common/Maybe";
import * as billPaymentAction from "store/entities/billPayment/action";
import { capitalizeBillerName } from 'utils/capitalizeBillerName'


export const BillPaymentProviders = React.forwardRef((props, ref) => {
    const dispatch = useDispatch();
    // const { providersLoading, providers } = useSelector((s) => s.entities.billPayment);
    const { providersLoading, providers } = props;


    const [options, setOptions] = useState([]);
    const [selectedOption, setSelectedOption] = useState({});


    const generateBillPaymentProviderName = (name) => {
        const name_split = name.split("_");
        const new_name = name_split.map((chunk) => {
            return (chunk.charAt(0).toUpperCase() + chunk.slice(1).toLowerCase());
        })
        return (new_name.join(" "));
    }


    const getOptions = () => {
        if (providers?.response !== undefined){
            const filteredProviders = providers?.response[props.type];
            if (filteredProviders !== undefined && filteredProviders.length > 0){
                const data = filteredProviders.map((provider) => {
                    return {
                        // label: generateBillPaymentProviderName(provider?.name),
                        label: (props.type === 'airtime' || props.type === 'data' || props.type === 'cableTv') ? capitalizeBillerName(provider?.name) : generateBillPaymentProviderName(provider?.name),
                        value: provider.name,
                        image: provider.image,
                    }
                })
                setOptions(data);
            }
            else{
                setOptions([]);
            }
        }
        else{
            setOptions([]);
        }
    }


    const updateSelection = (e) => {
        setSelectedOption(e);
        props.onValueChange(e);
    }


    const clearBillPaymentProviders = () => {
        setSelectedOption({});
    }


    useEffect(() => {
        dispatch(billPaymentAction.getProviders());
        // eslint-disable-next-line
    }, []);


    useEffect(() => {
        if (providers?.status === "success"){
            getOptions();
        }
        // eslint-disable-next-line
    }, [providers]);


    useImperativeHandle(ref, () => ({
        clearBillPaymentProviders,
        setSelectedOption
    }));
    
    
    


    return (
        <div className="form-group">
            
            <label>
                {props.label}
            </label>
            
            <Maybe condition={providersLoading === true}>
                <input type="text" value={"Loading "+props.tag+"..."} readOnly={true} className="form-input" />
            </Maybe>

            <Maybe condition={providersLoading === false}>
                
                <Maybe condition={selectedOption?.image?.length > 0}>
                    <div className="w-10 h-10 flex items-center justify-center absolute top-[20px] left-2 z-50">
                        <img
                            src={selectedOption?.image}
                            alt="icon"
                            width={25}
                        />
                    </div>                    
                </Maybe>
                
                <ReactSelect
                    options={options}
                    placeholder="Choose from list"
                    noOptionsMessage={() => "No "+props.tag+" yet"}
                    styles={ReactSelectStyles}
                    isMulti={false}
                    closeMenuOnSelect={true}
                    hideSelectedOptions={false}
                    components={{Option}}
                    onChange={(e) => updateSelection(e)}
                    value={selectedOption}
                />
            </Maybe>
        </div>
    )
})



const Option = (props) => {

    const getBillPaymentProviderColor = (provider) => {
        const bgColors = {
            "mtn": "bg-[#facb31]",
        }
        return bgColors[provider.toLowerCase()] || "bg-white";
    }

    return (
        <div className="p-0">
            <components.Option {...props}>
                <div className="-mx-2 -my-1.5 px-4 py-2 text-sm flex items-center justify-between rounded-sm">
                    <div className="flex-grow text-left">
                        <div className="flex space-x-4 items-center">
                            <div className={"w-8 h-8 flex items-center rounded-full overflow-hidden " + getBillPaymentProviderColor(props.label)}>
                                <img src={props.data.image} alt={props.label} className="object-contain" />
                            </div>
                            <div>
                                {props.label}
                            </div>
                        </div>
                    </div>
                </div>
            </components.Option>
        </div>
    );
};


  
const ReactSelectStyles = {
    option: (provided, state) => ({
        ...provided,
        color: "#333",
        background: "#fff",
        cursor: "pointer",
        "&:hover": {
            background: "#F3F5F6",
        }
    }),
    
    control: (provided, state) => ({
        ...provided,
        border: "1px solid #ddd",
        paddingLeft: "35px",
        boxShadow: "none",
        outline: "none",
        "&:hover": {
            border: "1px solid #F3F5F6",
            outline: "none",
        },
    }),
};

  

export default BillPaymentProviders;
